import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeLoginPage from "@/pages/employee/EmployeeLoginPage";

export const Route = createFileRoute("/employee/login")({
  head: () => pageHead("Employee Sign In", "AKIVA employee portal sign-in.", "/employee/login", true),
  component: EmployeeLoginPage,
});
